import { AnimatePresence, motion } from "framer-motion";
import { graphql } from "gatsby";
import { useStaticQuery } from "gatsby";
import React from "react";

const AnimWrapper = ({children}) => {

    const data = useStaticQuery(graphql`
    query transitionQuery{
        wp {
            acfOptionsAlgemeneInstellingen {
            algemeneInstellingen {
                paginaTransities {
                    paginaTransitie
                }
            }
            }
        }
        }`)

    const transition = data.wp.acfOptionsAlgemeneInstellingen.algemeneInstellingen.paginaTransities.paginaTransitie
    let initial;
    let animate;
    let exit;

    if(transition == 'fade'){
        initial = {
            opacity: 0
        }
        animate = {
            opacity: 1
        }
        exit = {
            opacity: 0
        }
    }else if(transition == 'slideL'){
        initial = {
            x: '100%'
        }
        animate = {
            x: '0'
        }
        exit = {
            x: '-100%'
        }
    }

    
    return(
           <motion.div initial={initial} animate={animate} exit={exit} transition={{ duration: .2 }}>{children}</motion.div>
    )
}

export default AnimWrapper;